import { useEffect } from 'react'

const DEFAULT_OG_IMAGE =
  'https://assets.auxodev.dk/assets/7090fdb0-7f55-4b6b-b1f9-a2c2b33a9494/forsiden.jpg'

function setMetaTag(selector, attrName, attrValue, content) {
  if (!content) return
  let element = document.querySelector(selector)
  if (!element) {
    element = document.createElement('meta')
    element.setAttribute(attrName, attrValue)
    document.head.appendChild(element)
  }
  element.setAttribute('content', content)
}

function setLinkTag(rel, href) {
  if (!href) return
  let element = document.querySelector(`link[rel="${rel}"]`)
  if (!element) {
    element = document.createElement('link')
    element.setAttribute('rel', rel)
    document.head.appendChild(element)
  }
  element.setAttribute('href', href)
}

export default function SEO({ title, description, image, url, type = 'website' }) {
  useEffect(() => {
    // 1. Page Title
    const pageTitle = title
      ? title.includes('Nordfyn Marine')
        ? title
        : `${title} - Nordfyn Marine`
      : 'Nordfyn Marine'
    document.title = pageTitle

    // 2. Page Description
    const pageDesc =
      description ||
      'Nordfyn Marine - Bådformidling og salg af sejlbåde, motorbåde og motorsejlere. Professionel rådgivning og Solgt eller gratis.'
    setMetaTag('meta[name="description"]', 'name', 'description', pageDesc)

    // 3. Current Canonical URL & OG URL
    const currentUrl = url || (typeof window !== 'undefined' ? window.location.href : '')
    setLinkTag('canonical', currentUrl)
    setMetaTag('meta[property="og:url"]', 'property', 'og:url', currentUrl)

    // 4. Open Graph Site Name & Type
    setMetaTag('meta[property="og:site_name"]', 'property', 'og:site_name', 'Nordfyn Marine')
    setMetaTag('meta[property="og:type"]', 'property', 'og:type', type)

    // 5. Open Graph Title & Description
    setMetaTag('meta[property="og:title"]', 'property', 'og:title', pageTitle)
    setMetaTag('meta[property="og:description"]', 'property', 'og:description', pageDesc)

    // 6. Twitter Card Tags
    setMetaTag('meta[name="twitter:card"]', 'name', 'twitter:card', 'summary_large_image')
    setMetaTag('meta[name="twitter:title"]', 'name', 'twitter:title', pageTitle)
    setMetaTag('meta[name="twitter:description"]', 'name', 'twitter:description', pageDesc)

    // 7. Extract and optimize OG Image URL
    let rawImg = image
    if (Array.isArray(rawImg) && rawImg.length > 0) {
      rawImg = rawImg[0]
    }
    if (typeof rawImg !== 'string' || !rawImg.trim()) {
      rawImg = DEFAULT_OG_IMAGE
    } else {
      rawImg = rawImg.trim()
    }

    // Ensure absolute URL
    let finalImg = rawImg
    if (finalImg.startsWith('/') && typeof window !== 'undefined') {
      finalImg = `${window.location.origin}${finalImg}`
    }

    // Use raw original image URL without /cdn-cgi/image/ transformation
    if (finalImg.includes('assets.auxodev.dk')) {
      // Strip any existing cdn-cgi transforms so crawlers read the original asset
      finalImg = finalImg.replace(/\/cdn-cgi\/image\/[^/]+\//i, '/')
    }

    // Set OG Image & Twitter Image Tags using original raw image
    setMetaTag('meta[property="og:image"]', 'property', 'og:image', finalImg)
    setMetaTag('meta[property="og:image:secure_url"]', 'property', 'og:image:secure_url', finalImg)
    setMetaTag('meta[property="og:image:alt"]', 'property', 'og:image:alt', pageTitle)
    setMetaTag('meta[name="twitter:image"]', 'name', 'twitter:image', finalImg)
  }, [title, description, image, url, type])

  return null
}
